import { Component } from '@angular/core';

@Component({
  selector: 'zip-co-country-switcher',
  templateUrl: './country-switcher.component.html',
  styleUrls: ['./country-switcher.component.scss'],
  standalone: false,
})
export class CountrySwitcherComponent {
  public isMenuActive: boolean = false;

  public countryItems: Array<{
    label: string;
    link: string;
    iconSrc: string;
    isCurrent: boolean;
  }> = [
    {
      label: 'Australia',
      link: '/',
      iconSrc: '/au/giftcards/assets/flag-au.svg',
      isCurrent: true,
    },
    {
      label: 'New Zealand',
      link: '/nz',
      iconSrc: '/au/giftcards/assets/flag-nz.svg',
      isCurrent: false,
    },
    {
      label: 'United States',
      link: '/us',
      iconSrc: '/au/giftcards/assets/flag-us.svg',
      isCurrent: false,
    },
  ];

  constructor() {}

  public toggleMenu(): void {
    this.isMenuActive = !this.isMenuActive;
  }
}
